<script setup lang="ts">
import { ref, computed } from "vue";
import CompanyBalance from "#/components/balance/CompanyBalance.vue";
import PayerSelect from "#/components/payer/PayerSelect.vue";
import RadioCardList, { Choice as RadioCardChoice } from "#/components/form/RadioCardList.vue";
import { employerAccountingApiV1 } from "#/../js/api/client";

const amount = ref("");
const selectedPayerId = ref("");
const selectedPayMethod = ref<PayMethod>("bill");
const formHandling = ref(false)
const formError = ref("");
const formSuccess = ref("");
const isFormFilled = computed(() => {
  return (
    amount.value !== "" &&
    selectedPayerId.value !== "" &&
    selectedPayMethod.value !== ""
  );
})

type PayMethod = "bill";
const payMethods = computed<Array<RadioCardChoice>>(() => {
  return [
    {
      value: "bill",
      title: "Оплата счету",
      description: "Сформируем счет для юридического лица",
      enabled: !!selectedPayerId.value,
    }
  ];
})

const handleSubmit = async () => {
  formSuccess.value = "";
  formError.value = "";
  formHandling.value = true;

  try {
    if (selectedPayMethod.value === "bill") {
      await employerAccountingApiV1.balance.requestBillToDepositBalance({
        price: parseInt(amount.value) * 100,
        payerId: selectedPayerId.value,
        comment: `Запрос счета на пополнение баланса`,
      })
      formSuccess.value = "Запрос счета на пополнение баланса успешно сформирован";
    }
  } catch (e) {
    formError.value = 'Ошибка отправки формы'
  } finally {
    formHandling.value = false;
  }
};
</script>

<template>
  <div>
    <company-balance sub-title="Счет для работы с кабинетом" class="mb-16" />

    <div class="alert alert-error" v-if="formError">{{ formError }}</div>

    <div v-if="formSuccess" class="alert alert-success">
      {{ formSuccess }}
    </div>

    <form class="form-balance" @submit.prevent="handleSubmit" v-else>
      <div class="py-16">
        <div class="mb-12">
          <label>
            Пополнить счет <span class="red">*</span>
          </label>
        </div>
        <input
          v-model="amount"
          type="number"
          required
          min="1"
          class="form-control form-balance__input-amount"
          placeholder="Сумма для пополнения счета"
        />
      </div>

      <div class="py-16">
        <payer-select v-model="selectedPayerId" required />
      </div>

      <div class="py-16">
        <div class="mb-12">
          <label>Выберите способ оплаты <span class="red">*</span></label>
        </div>
        <radio-card-list
            :choices="payMethods"
            v-model="selectedPayMethod"
            required
        />
      </div>

      <div class="form-balance__submit-block py-16">
        <button class="btn form-balance__submit" type="submit" :disabled="formHandling || !isFormFilled">
          Сформировать счет для оплаты
        </button>
      </div>
    </form>
  </div>
</template>

<style scoped lang="scss">
.form-balance {
  .form-balance__input-amount {
    margin-bottom: 0;
    -moz-appearance:textfield;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }
  }
  .form-balance__submit-block {
    text-align: right;
  }

  .form-balance__submit {
    display: inline-block;
    padding-left: 40px;
    padding-right: 40px;

    @media (screen and max-width: 576px) {
      width: 100%;
    }
  }
}
</style>
